import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL_V2, STORE_BASE_PATH } from '../../common/constants';
import { prepareHeaders } from '../tokenHandling/prepareHeaders';

export const facadeApiV2 = createApi({
    reducerPath: `${STORE_BASE_PATH}facadeApiV2`,
    baseQuery: fetchBaseQuery({ baseUrl: BASE_URL_V2, prepareHeaders }),
    endpoints: builder => ({}),
});
